var handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };

/**
 * Performs a search to return attribute information for layers.
 */
export default function getLayerItemInformation(x,y, layers, sDispatch) {

    const abortController = new AbortController();

      let mounted = true;
      (async () => {  
        const res = await fetch(process.env.REACT_APP_FIND_API+'/mapping/information?x='+x+'&y='+y+'&layers='+layers, {
          method: 'GET',
          headers: {'Content-Type': 'application/json'},
          signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
          
          if (data.status === "success"){
            console.log("LayerItemInformation Function: "+JSON.stringify(data.data));
            sDispatch({
              type: "setLayerInformation",
              payload: { layerInformation: data.data }
            });
            
          } else {
          }
        }
        const cleanup = () => {
          mounted = false;
          abortController.abort();
        };
        return cleanup;
    
    })();
}